import {
  CheckCircleFilled,
  InfoCircleOutlined,
  RightOutlined,
} from "@ant-design/icons";
import { Button, Skeleton, Tooltip } from "antd";
import { useEffect, useState } from "react";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { cardData } from "../scripts/products";
import { useNavigate } from "react-router-dom";

const ProductsSliderComp = () => {
  const [current, setCurrent] = useState(1);
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 2000);
  }, []);

  const settings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };
  const settings2 = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 2,
    slidesToScroll: 1,
  };

  return (
    <div>
      <div className="white-block">
        <div className="flex-end">
          <div className="grey">
            <h1 className="">Конкуренты размещают</h1>
            <span>
              <CheckCircleFilled className="green" /> <b>Новые позиции</b>{" "}
              продукции, размещенные предприятиями отрасли
            </span>
          </div>
          <Button>Открыть полный список</Button>
        </div>
        <div>
          <div className="slider3">
            <Slider {...settings2}>
              {cardData
                .slice(4,9)
                .map(({ id, images, price, title, seller }, index) => (
                  <div className="card" key={index}>
                    <div className="grid1-2">
                      <div>
                        {images?.length > 0 ? (
                          images?.length > 1 ? (
                            <Slider {...settings}>
                              {images.map((img, i) => (
                                <div>
                                  <img
                                    src={img}
                                    alt={title}
                                    key={i}
                                    className={"image"}
                                  />
                                </div>
                              ))}
                            </Slider>
                          ) : (
                            <img
                              src={images[0]}
                              alt={title}
                              className={"image"}
                            />
                          )
                        ) : (
                          <img src={"/not-image.png"} className={"image"} />
                        )}
                      </div>

                      <div>
                        <h2>{title}</h2>

                        <h3>{seller}</h3>
                        <p className="title">
                          <div className="grey">Отпускная цена: </div>
                          {price.toLocaleString("ru-RU")} рублей
                        </p>
                        <Button onClick={() => navigate(`/product/${id}`)}>
                          Открыть карточку товара
                        </Button>
                      </div>
                    </div>
                  </div>
                ))}
            </Slider>
          </div>
        </div>
      </div>
    </div>
  );
};
export default ProductsSliderComp;
